import React, {useEffect} from 'react';
import {navigate} from '@reach/router';
import MasterclassIndex from '../../masterclass/health';

export default function () {
  useEffect(() => {
    navigate('/a-l/masterclass/health/' + location.search);
  }, []);
  return <MasterclassIndex noFixedVideo noExitIntent variant="ad" entry="health" />;
}
